import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../state/actions'
import { bindActionCreators } from 'redux'
import { browserHistory } from 'react-router'
import moment from 'moment'
import momentLocalizer from 'react-widgets/lib/localizers/moment'
import yup from 'yup'
import Form from 'react-formal'
import types from 'react-formal-inputs'
import 'react-widgets/lib/less/react-widgets.less'

class UserAdd extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }

        function samePassword() {
            let parent = this.parent
            return parent.password === parent.validation
        }

        function hasANumber() {
            let parent = this.parent
            if (parent.password.match(/\d+/g) === null) {
                return false
            } else {
                return true
            }
        }

        function hasAnUpperCaseLetter() {
            let parent = this.parent
            if (parent.password.toLowerCase() === parent.password) {
                return false
            } else {
                return true
            }
        }

        this.modelSchema = yup.object({
            username: yup.string().lowercase().email('El username debe ser un email').required('Ingrese un username'),
            passwords: yup.object({
                password: yup.string().required('Ingrese una contraseña').min(8, 'Debe tener minimo 8 caracteres').test('has-a-number', 'Debe contener al menos un numero', hasANumber).test('has-an-upper-case-letter', 'Debe contener al menos una letra mayuscula', hasAnUpperCaseLetter),
                validation: yup.string().required('Vuelva a ingresar su contraseña').min(8, 'Debe tener minimo 8 caracteres').test('passwords-match', 'Las contraseñas no coinciden', samePassword).test('has-a-number', 'Debe contener al menos un numero', hasANumber).test('has-an-upper-case-letter', 'Debe contener al menos una letra mayuscula', hasAnUpperCaseLetter)
            }),
            name: yup.object({first: yup.string().required('Ingrese su nombre'), last: yup.string().required('Ingrese su apellido')}),
            rank: yup.number().required('Seleccione un rango')
        })

        Form.addInputTypes(types)
        momentLocalizer(moment)
    }

    goBack() {
        browserHistory.go(-1)
    }

    registerForm(formValues) {
        let self = this
        let username = formValues.username
        let password = formValues.passwords.password
        let name = formValues.name.first
        let surname = formValues.name.last
        let displayName = formValues.name.first + ' ' + formValues.name.last
        let profile = formValues.rank

        self.setState({ loading: true })

        self.props.actions.userAdd(self.props.params.appCodename, {
            username: username,
            password: password,
            displayName: displayName,
            name: {
                familyName: surname,
                givenName: name
            },
            emails: [
                {
                    value: username,
                    type: 'work'
                }
            ],
            photos: [],
            profile: profile
        }).then(function() {
            self.setState({ loading: false })
            self.goBack()
        })
    }
    getRolAdminAvailable() {
        let self = this
        if (self.props.profile && self.props.profile.profile === 2000) {
            return <option value={1000}>ADMIN</option>
        }

        return
    }
    render() {
        let self = this
        return (
            <div>
                <div className="row">
                    <div className="col-lg-12">
                        <h1 className="page-header">Agregar Usuario</h1>
                    </div>
                </div>

                <Form schema={self.modelSchema} defaultValue={self.modelSchema.default()} onSubmit={self.registerForm.bind(self)} className='col-xs-12'>
                    <div className="row">
                        <div className='form-group col-xs-6 col-md-6' key='username'>
                            <label>Username</label>
                            <Form.Field name='username' placeholder='username@mail.com' className='form-control'/>
                            <Form.Message for={'username'}/>
                        </div>
                        <div className='form-group col-xs-6 col-md-6' key='roles'>
                            <label>Rol</label>
                            <Form.Field name='rank' type='select' className='form-control'>
                                <option value={undefined}>Seleccione un rol...</option>
                                {self.getRolAdminAvailable()}
                            </Form.Field>
                            <Form.Message for={'rank'}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className='form-group col-xs-6 col-md-6' key='password'>
                            <label>Contraseña</label>
                            <Form.Field name='passwords.password' placeholder='Contraseña123' className='form-control' type='password'/>
                            <Form.Message for={'passwords.password'}/>
                        </div>
                        <div className='form-group col-xs-6 col-md-6' key='validation'>
                            <label>Validación</label>
                            <Form.Field name='passwords.validation' placeholder='Contraseña123' className='form-control' type='password'/>
                            <Form.Message for={'passwords.validation'}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className='form-group col-xs-6 col-md-6' key='nombre'>
                            <label>Nombre</label>
                            <Form.Field name='name.first' placeholder='Nombre' className='form-control'/>
                            <Form.Message for={'name.first'}/>
                        </div>
                        <div className='form-group col-xs-6 col-md-6' key='apellido'>
                            <label>Apellido</label>
                            <Form.Field name='name.last' placeholder='Apellido' className='form-control'/>
                            <Form.Message for={'name.last'}/>
                        </div>
                    </div>
                    <div className='form-group col-md-12'>
                        <div className='pull-right'>
                            <Form.Button type='submit' className='btn btn-primary' disabled={ self.state.loading }>Guardar</Form.Button>
                            &nbsp;
                            <button className="btn btn-danger" type="button" onClick={self.goBack.bind(self)} disabled={ self.state.loading }>Cancelar</button>
                        </div>
                    </div>
                </Form>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        profile: state.profile
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(UserAdd)



// WEBPACK FOOTER //
// ./components/UserAdd/index.js